import React from 'react';

import {Services} from 'presentation/pages';

export const MakeServicesPage: React.FC = () => {
	return <Services />;
};
